module.exports = __webpack_public_path__ + "media/interview-sm.e8ff1593.mp4";